"use strict";

var _classCallCheck = require("/Users/bryan/Documents/Projects/ssat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/bryan/Documents/Projects/ssat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var API2PDF_BASE_ENDPOINT = "https://v2018.api2pdf.com";
var API2PDF_MERGE = API2PDF_BASE_ENDPOINT + "/merge";
var API2PDF_WKHTMLTOPDF_HTML = API2PDF_BASE_ENDPOINT + "/wkhtmltopdf/html";
var API2PDF_WKHTMLTOPDF_URL = API2PDF_BASE_ENDPOINT + "/wkhtmltopdf/url";
var API2PDF_CHROME_HTML = API2PDF_BASE_ENDPOINT + "/chrome/html";
var API2PDF_CHROME_URL = API2PDF_BASE_ENDPOINT + "/chrome/url";
var API2PDF_LIBREOFFICE_CONVERT = API2PDF_BASE_ENDPOINT + "/libreoffice/convert";

var request = require('request');

module.exports =
/*#__PURE__*/
function () {
  function Api2Pdf(apiKey) {
    _classCallCheck(this, Api2Pdf);

    this.apiKey = apiKey;
  }

  _createClass(Api2Pdf, [{
    key: "headlessChromeFromUrl",
    value: function headlessChromeFromUrl(url) {
      var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var payload = {
        url: url,
        inlinePdf: inline
      };

      if (filename != null) {
        payload['fileName'] = filename;
      }

      if (options != null) {
        payload['options'] = options;
      }

      return this._makeRequest(API2PDF_CHROME_URL, payload);
    }
  }, {
    key: "headlessChromeFromHtml",
    value: function headlessChromeFromHtml(html) {
      var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var payload = {
        html: html,
        inlinePdf: inline
      };

      if (filename != null) {
        payload['fileName'] = filename;
      }

      if (options != null) {
        payload['options'] = options;
      }

      return this._makeRequest(API2PDF_CHROME_HTML, payload);
    }
  }, {
    key: "wkhtmltopdfFromUrl",
    value: function wkhtmltopdfFromUrl(url) {
      var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var payload = {
        url: url,
        inlinePdf: inline
      };

      if (filename != null) {
        payload['fileName'] = filename;
      }

      if (options != null) {
        payload['options'] = options;
      }

      return this._makeRequest(API2PDF_WKHTMLTOPDF_URL, payload);
    }
  }, {
    key: "wkhtmltopdfFromHtml",
    value: function wkhtmltopdfFromHtml(html) {
      var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var payload = {
        html: html,
        inlinePdf: inline
      };

      if (filename != null) {
        payload['fileName'] = filename;
      }

      if (options != null) {
        payload['options'] = options;
      }

      return this._makeRequest(API2PDF_WKHTMLTOPDF_HTML, payload);
    }
  }, {
    key: "merge",
    value: function merge(urls) {
      var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var payload = {
        urls: urls,
        inlinePdf: inline
      };

      if (filename != null) {
        payload['fileName'] = filename;
      }

      return this._makeRequest(API2PDF_MERGE, payload);
    }
  }, {
    key: "libreofficeConvert",
    value: function libreofficeConvert(url) {
      var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var filename = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var payload = {
        url: url,
        inlinePdf: inline
      };

      if (filename != null) {
        payload['fileName'] = filename;
      }

      return this._makeRequest(API2PDF_LIBREOFFICE_CONVERT, payload);
    }
  }, {
    key: "delete",
    value: function _delete(responseId) {
      var _this = this;

      var endpoint = API2PDF_BASE_ENDPOINT + "/pdf/".concat(responseId);
      return new Promise(function (resolve, reject) {
        request.delete(endpoint, {
          headers: {
            Authorization: _this.apiKey
          }
        }, function (e, r, body) {
          var result = JSON.parse(body);

          if (r.statusCode == 200 && result.success == true) {
            return resolve(result);
          } else {
            return reject(result);
          }
        });
      });
    }
  }, {
    key: "_makeRequest",
    value: function _makeRequest(endpoint, payload) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        request.post({
          url: endpoint,
          body: JSON.stringify(payload),
          headers: {
            Authorization: _this2.apiKey
          }
        }, function (e, r, body) {
          var result = JSON.parse(body);

          if (r.statusCode == 200 && result.success == true) {
            return resolve(result);
          } else {
            return reject(result);
          }
        });
      });
    }
  }]);

  return Api2Pdf;
}();